import $ from "jquery";
import { Fragment, useCallback, useContext, useEffect, useState } from "react";
import { headerLogo } from "../../assets/imageImport";
import { BulkButOption } from "../Common/BulkBuyPopup";
import { ShopAllProducts } from "./shopAllproducts";
import { SearchSuggestion } from "./SearchSuggestion";
import { Link, useLocation } from "react-router-dom";
import { SideBar } from "./sidebar";
import { GlobalContext } from "../../Context/GlobalContext";
import { WishListToaster } from "./WishListToaster";
import { MyFavouriteToaster } from "../Common/myFavouriteToaster";
import { MyFavouriteToasterSimple } from "../Common/myFavouriteToasterSimple";
import { OrderClarificationModal } from "../Common/orderClarificationModal";
import { CartSidePopup } from "./cartSidePopup/cartSidePopup";
import { useAuth } from "../../Context/AuthContext";

import { WishlistContext } from "../../Context/WishlistContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useGlobalFunction } from "../../Context/GlobalFunctionContext";
import { MyAccountMenu } from "./myAccountMenu";
import { PAGES } from "../../routeConfig";
import { useLoginModal } from "../../Context/LoginModalContext";
import { handleCloseSideBar } from "../Common/common";
import { GoToTop } from "../Common/goToTop";
import { SearchSuggestionMobile } from "./SearchSuggestionMobile";
import { QuickOrderMain } from "../../View/QuickOrder/quickOrdSidePopup/QuickOrderMain";
import { QuickMenu } from "../../View/HomeNew/quickMenu";
import { NotificationContainer } from "../Common/NotificationContainer";
import { ToastContainer, Zoom, Bounce, Flip, cssTransition, Slide } from "react-toastify";
import { PreviousOrderPopup } from "../Common/PopUp/previousOrderPopUp";
import { OverDuePopup } from "../Common/PopUp/overDuePopUp";

// ==============|| MAIN LAYOUT ||============== //

export const MainLayout = () => {
  const { CartItem } = useContext(GlobalContext);
  const { userId, userName, role, isAuthenticated, isBrowseOnly, showWelcomepopup } = useAuth();
  const { pathname } = useLocation();
  const isHomePage = pathname === "/" || pathname.toLowerCase() === PAGES.HOME.toLowerCase();
  const { logout } = useGlobalFunction();
  const { showLoginModal } = useLoginModal();
  const [hasCartItems, sethasCartItems] = useState(0);
  const [overDueDone, setOverDueDone] = useState(false);
  const handleOverDueDone = useCallback(() => setOverDueDone(true), []);
  const handleGuestLogin = (e) => {
    e.preventDefault();
    if (String(window.location.pathname).toLocaleLowerCase().includes("login")) return;
    showLoginModal({ title: "Login to Continue", heading: "Welcome. Please Login!" });
  };
  const CustomTransition = cssTransition({
    enter: "fadeIn",
    exit: "fadeOut",
    duration: [150, 150],
  });
  useEffect(() => {
    try {
      var _model = $(".allproducts-close");
      if (_model.length > 0) {
        _model[0].click();
        _model.each(function () {
          $(this).click();
        });
      } else _model.click();

      setTimeout(headerActionOnScroll(), 1000);
    } catch {}
  }, [window.location.pathname]);
  useEffect(() => {
    if (CartItem && CartItem.cartItem && CartItem.cartItem.length > 0) {
      const hasItems = CartItem.cartItem.length;

      sethasCartItems(hasItems);
    } else {
      sethasCartItems(0);
    }
  }, [CartItem]);

  function headerActionOnScroll() {
    let lastScrollTop = 0;
    const header = $(".header-area");
    function isMobile() {
      return $(window).width() > 768;
    }

    $(window).on("scroll", function () {
      if (!isMobile()) return; // Run only on mobile view
      let scrollTop = $(this).scrollTop();
      if (scrollTop > 50 && lastScrollTop <= 50) {
        header.addClass("header-mini");
      } else if (scrollTop <= 50 && lastScrollTop > 50) {
        header.removeClass("header-mini");
      }

      lastScrollTop = scrollTop;
    });
  }

  return (
    <Fragment>
      <div>
        <div className="main-wrapper">
          {/* Menu Sidebar */}
          <div className="sidebar-wrap">
            <div className="sidebar-inner">
              <div className="sidebar-close">
                <div className="sidebar-close-btn" onClick={handleCloseSideBar}>
                  <i className="fa-solid fa-arrow-left" />
                  Back to Home
                </div>
              </div>
              <SideBar />
            </div>
          </div>
          {/* Menu Sidebar */}
          {/* Header section */}
          <header className={`header-area fixed-top${isAuthenticated ? "" : " about-guest-header"}`}>
            <div className="container-fluid container-lg p-0">
              <div className="header-navbar">
                <nav className="navbar navbar-expand-lg navbar-light">
                  <div className="container-fluid container-lg">
                    <Link className="navbar-brand" to="/home">
                      <img src={headerLogo} alt="Logo" />
                    </Link>
                    <div className="navbar-collapse nav-links">
                      <div
                        className="category-nav mb-2 mb-lg-0"
                        data-bs-toggle="modal"
                        data-bs-target={`${isAuthenticated ? "#shop-allProducts" : "#loginModal"}`}
                      >
                        <div className="shop-categories">
                          <i className="fa-solid fa-bars" />
                          <p>Shop All Products</p>
                        </div>
                        <span className="wes-down-arrow d-none d-lg-block" />
                      </div>
                      <SearchSuggestion />
                      {isAuthenticated ? (
                        <div className="d-flex header-right">
                          <MyAccountMenu />
                          <SearchSuggestionMobile />
                          {!isBrowseOnly && (
                            <div
                              className="header-user header-cart d-flex"
                              data-bs-toggle="offcanvas"
                              data-bs-target={hasCartItems == 0 ? "#quickOrder-popup" : "#cartPopup"}
                              aria-controls={hasCartItems == 0 ? "offcanvasRight" : "offcanvasTop"}
                            >
                              <a href="#" onClick={(e) => e.preventDefault()} className="cart-icon">
                                <span className="wes-cart" />
                              </a>

                              <div className="header-cart shopping-cart">
                                <a href="#" onClick={(e) => e.preventDefault()}>
                                  {CartItem?.totalItem ?? 0}
                                </a>
                              </div>
                            </div>
                          )}
                        </div>
                      ) : (
                        <div className="d-flex header-right guest-actions">
                          <SearchSuggestionMobile />
                          <a className="btn guest-login" href="#" onClick={handleGuestLogin}>
                            <i className="fa-regular fa-user" aria-hidden="true" /> <span>Login</span>
                          </a>
                          <Link className="btn guest-account" to={PAGES.SIGNUP}>
                            <i className="fa-solid fa-briefcase" aria-hidden="true" /> <span>Open Trade Account</span>{" "}
                            <i className="fa-solid fa-arrow-right" aria-hidden="true" />
                          </Link>
                        </div>
                      )}
                    </div>
                  </div>
                  <div id="cart-notification-root"></div>
                  <ToastContainer
                    position="top-right"
                    autoClose={false}
                    hideProgressBar={true}
                    pauseOnFocusLoss
                    closeOnClick={false}
                    pauseOnHover
                    transition={CustomTransition}
                  />
                </nav>
                {/* <MyFavouriteToaster /> */}
                <MyFavouriteToasterSimple />
              </div>
            </div>
          </header>
        </div>
        {!isBrowseOnly && <PreviousOrderPopup canShow={!isAuthenticated || overDueDone} />}
        {isAuthenticated && <OverDuePopup onDone={handleOverDueDone} canShow={!(showWelcomepopup && isHomePage)} />}
        <GoToTop />
        <ShopAllProducts />
        <WishListToaster />
        <QuickOrderMain />
        <CartSidePopup />
      </div>
      <QuickMenu />
    </Fragment>
  );
};
